/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ChangeStatusRequest } from '../model/models';
import { GroupResource } from '../model/models';
import { ItemResource } from '../model/models';
import { ToggleDashboardGroupRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface DashboardServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Change item status
     * 
     * @param id 
     * @param changeStatusRequest 
     */
    changeStatus(id: string, changeStatusRequest?: ChangeStatusRequest, extraHttpRequestParams?: any): Observable<ItemResource>;

    /**
     * Get dashboard
     * 
     */
    getDashboard(extraHttpRequestParams?: any): Observable<GroupResource>;

    /**
     * Toggle dashboard group
     * 
     * @param id 
     * @param toggleDashboardGroupRequest 
     */
    toggleDashboardGroup(id: string, toggleDashboardGroupRequest?: ToggleDashboardGroupRequest, extraHttpRequestParams?: any): Observable<GroupResource>;

}
